const numberInputs = {
  init() {
    this.setInputs();
    this.addEvents();
  },

  setInputs() {
    const inputWraps = document.querySelectorAll(
      '.jsCustomNumberInput',
    ) as NodeListOf<HTMLElement>;

    inputWraps.forEach((item) => {
      const plus = item.querySelector('.jsPlus') as HTMLElement;
      const minus = item.querySelector('.jsMinus') as HTMLElement;
      const input = item.querySelector('.jsNumberInput') as HTMLInputElement;
      const numberHtml = item.querySelector('.jsNumber') as HTMLElement;

      const min = Number(input.getAttribute('min')) || 0;
      const maxAttr = input.getAttribute('max');
      const max = maxAttr ? Number(maxAttr) : Infinity;

      const setNumber = (value: number, shouldDispatch = true) => {
        let number = value;

        if (number < min) number = min;
        if (number > max) number = max;

        input.value = number.toString();
        numberHtml.innerText = number.toString();

        if (shouldDispatch) {
          window.dispatchEvent(window.qtyChangeEvent);
        }
      };

      // Safety clamp on load
      setNumber(Number(input.value) || min, false);

      plus?.addEventListener('click', () => {
        if (input.disabled) return;

        const currentNumber = Number(input.value) || min;

        if (currentNumber < max) {
          setNumber(currentNumber + 1);
        }
      });

      minus?.addEventListener('click', () => {
        if (input.disabled) return;

        const currentNumber = Number(input.value) || min;

        if (currentNumber > min) {
          setNumber(currentNumber - 1);
        }
      });
    });
  },

  addEvents() {
    const inputWraps = document.querySelectorAll(
      '.jsCustomNumberInput',
    ) as NodeListOf<HTMLElement>;

    if (inputWraps.length) {
      window.addEventListener('resetQty', () => {
        inputWraps.forEach((item) => {
          const input = item.querySelector(
            '.jsNumberInput',
          ) as HTMLInputElement;

          const numberHtml = item.querySelector('.jsNumber') as HTMLElement;

          const min = Number(input.getAttribute('min')) || 0;

          input.value = min.toString();
          numberHtml.innerText = min.toString();
        });
      });
    }
  },
};

export default numberInputs;